/**Packages */
import React from 'react';
import { useSelector } from 'react-redux';
/* Helpers */
import { getIfInternalThemeIsBaseSimulator } from "../../../helpers/utils";
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';

export const RetrieveEstimateLink = () => {
  const internalTheme = useSelector(state => state.internalTheme);

  return getIfInternalThemeIsBaseSimulator(internalTheme) && (
    <div className="retrieve-text-scp">Hai già calcolato un preventivo e hai ricevuto il tracking code? <a href={getPartnerEndpoints("compass").redirect.estimateRedirect} target="_blank" rel="noreferrer">Clicca qui</a> per recuperare il tuo preventivo.</div>
  );
}
